module.exports = __webpack_public_path__ + "media/images/brussels/offers/digital-voucher-app@2x-ede94fb32f84afc6913dab01aaf83756.jpg";